import Vue from 'vue';
import Router from 'vue-router';
import { fetchCandidate } from './middleware';

Vue.use(Router);

export default store => new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'landing',
      component: () => import(/* webpackChunkName: "landing" */ '../app/AppLanding.vue'),
    },
    {
      path: '/promo/qr',
      name: 'qr-promo',
      component: () => import(/* webpackChunkName: "qr-promo" */ '../app/AppQrLanding'),
    },
    {
      path: '/promo/social',
      name: 'social-promo',
      component: () => import(/* webpackChunkName: "social-promo" */ '../app/AppSocialLanding'),
    },
    {
      path: '/:lang/demo',
      name: 'demo',
      component: () => import('../views/DemoInterviewFetcher.vue'),
      props: route => ({
        lang: route.params.lang,
      }),
    },
    {
      path: '/v/:vacancyId',
      name: 'vacancyShort',
      component: () => import(/* webpackChunkName: "vacancy-redirect" */ '../views/ShortVacancyRedirect.vue'),
      props: route => ({
        vacancyId: Number.parseInt(route.params.vacancyId, 10),
      }),
    },
    {
      path: '/iframe/company/:companyId/apply/vacancy/:vacancyId',
      name: 'applyVacancyIframe',
      component: () => import(/* webpackChunkName: "vacancy-interview" */ '../forms/IframeCandidateProfileForm'),
      props: route => ({
        vacancyId: Number.parseInt(route.params.vacancyId, 10),
        companyId: Number.parseInt(route.params.companyId, 10),
      }),
    },
    {
      path: '/iframe/company/:companyId/vacancy/:vacancyId/interview/:step?',
      name: 'interviewIframe',
      beforeEnter: fetchCandidate.bind(store),
      component: () => import(/* webpackChunkName: "vacancy-interview" */ '../views/Interview.vue'),
      props: route => ({
        vacancyId: Number.parseInt(route.params.vacancyId, 10),
        companyId: Number.parseInt(route.params.companyId, 10),
        step: route.params.step ? Number.parseInt(route.params.step, 10) : undefined,
        isIosDevice: route.params.isIosDevice,
      }),
      meta: {
        iframe: true,
        supportBtn: true,
      },
    },
    {
      path: '/iframe/company/:companyId/vacancy/:vacancyId/interview/:step?',
      name: 'IframeAppIosMessage',
      beforeEnter: fetchCandidate.bind(store),
      component: () => import(/* webpackChunkName: "iframe-app-ios-message" */ '../components/IframeAppIosMessage'),
      props: route => ({
        vacancyId: Number.parseInt(route.params.vacancyId, 10),
        companyId: Number.parseInt(route.params.companyId, 10),
        step: route.params.step ? Number.parseInt(route.params.step, 10) : undefined,
      }),
      meta: {
        iframe: true,
      },
    },
    {
      path: '/iframe/company/:companyId/vacancy/:vacancyId/test_interview/:step?',
      name: 'iframe_interview_test',
      component: () => import(/* webpackChunkName: "vacancy-interview" */ '../views/InterviewTest.vue'),
      props: route => ({
        vacancyId: Number.parseInt(route.params.vacancyId, 10),
        step: route.params.step ? Number.parseInt(route.params.step, 10) : undefined,
      }),
      meta: {
        supportBtn: true,
        iframe: true,
      },
    },
    {
      path: '/iframe/vacancy/:vacancyId/continue',
      name: 'iframeInterviewContinue',
      beforeEnter: fetchCandidate.bind(store),
      component: () => import(/* webpackChunkName: "vacancy-interview-continue" */ '../views/InterviewContinue.vue'),
      props: route => ({
        vacancyId: Number.parseInt(route.params.vacancyId, 10),
        companyId: Number.parseInt(route.params.companyId, 10),
      }),
      meta: {
        iframe: true,
      },
    },
    {
      path: '/iframe/vacancy/:vacancyId/continue_test',
      name: 'iframeInterviewTestContinue',
      beforeEnter: fetchCandidate.bind(store),
      component: () => import(/* webpackChunkName: "vacancy-interview-continue-test" */ '../views/InterviewTestContinue.vue'),
      props: route => ({ vacancyId: Number.parseInt(route.params.vacancyId, 10) }),
      meta: {
        iframe: true,
      },
    },
    {
      path: '/iframe/vacancy/:vacancyId/result',
      name: 'iframeInterviewResult',
      beforeEnter: fetchCandidate.bind(store),
      component: () => import(/* webpackChunkName: "interview-result" */ '../views/InterviewResult.vue'),
      props: route => ({
        companyId: Number.parseInt(route.params.companyId, 10),
        vacancyId: Number.parseInt(route.params.vacancyId, 10),
      }),
      meta: {
        iframe: true,
      },
    },
    {
      path: '/company/:companyId',
      component: () => import(/* webpackChunkName: "app-company" */ '../app/AppCompany.vue'),
      children: [
        {
          path: '',
          name: 'company',
          component: () => import(/* webpackChunkName: "company" */ '../views/Company.vue'),
          props: route => ({ id: Number.parseInt(route.params.companyId, 10) }),
        },
        {
          path: 'vacancies',
          name: 'vacancies',
          component: () => import(/* webpackChunkName: "vacancies" */ '../views/Vacancies.vue'),
          props: route => ({
            id: Number.parseInt(route.params.companyId, 10),
          }),
        },
        {
          path: 'apply/vacancy/:vacancyId',
          name: 'applyOnVacancy',
          component: () => import(/* webpackChunkName: "candidate-refuse" */ '../views/ApplyOnVacancy.vue'),
          props: route => ({ vacancyId: Number.parseInt(route.params.vacancyId, 10) }),
        },
        {
          path: 'apply/success/vacancy/:vacancyId',
          name: 'applyOnVacancySuccess',
          component: () => import(/* webpackChunkName: "candidate-refuse" */ '../views/ApplySuccess.vue'),
          props: route => ({ vacancyId: Number.parseInt(route.params.vacancyId, 10) }),
        },
        {
          path: 'vacancy/:vacancyId',
          name: 'vacancy',
          component: () => import(/* webpackChunkName: "vacancy" */ '../views/Vacancy.vue'),
          props: route => ({ id: Number.parseInt(route.params.vacancyId, 10) }),
          children: [
            {
              path: 'refuse/:hashId',
              name: 'candidateRefuse',
              component: () => import(/* webpackChunkName: "candidate-refuse" */ '../views/CandidateRefuse.vue'),
              props: route => ({ hashId: String(route.params.hashId) }),
            },
            {
              path: 'support/:hashId',
              name: 'candidateSupport',
              component: () => import(/* webpackChunkName: "candidate-support" */ '../views/CandidateSupport.vue'),
              props: route => ({ hashId: String(route.params.hashId) }),
            },
            {
              path: 'feedback/:hashId',
              name: 'candidateFeedback',
              component: () => import(/* webpackChunkName: "candidate-feedback" */ '../views/CandidateFeedback.vue'),
              props: route => ({ hashId: String(route.params.hashId) }),
            },
            {
              path: 'waiting',
              name: 'CandidateWaiting',
              component: () => import(/* webpackChunkName: "candidate-waiting" */ '../views/CandidateWaiting.vue'),
            },
          ],
        },
        {
          path: 'vacancy/:vacancyId/reply/:hashId?',
          name: 'vacancyReply',
          component: () => import(/* webpackChunkName: "vacancy-reply" */ '../views/VacancyReply.vue'),
          props: route => ({
            vacancyId: Number.parseInt(route.params.vacancyId, 10),
            hashId: route.params.hashId,
          }),
        },
        {
          path: 'vacancy/:vacancyId/interview/:step?',
          name: 'interview',
          component: () => import(/* webpackChunkName: "vacancy-interview" */ '../views/Interview.vue'),
          props: route => ({
            vacancyId: Number.parseInt(route.params.vacancyId, 10),
            step: route.params.step ? Number.parseInt(route.params.step, 10) : undefined,
          }),
          meta: {
            supportBtn: true,
          },
        },
        {
          path: 'vacancy/:vacancyId/test_interview/:step?',
          name: 'interview_test',
          component: () => import(/* webpackChunkName: "vacancy-interview" */ '../views/InterviewTest.vue'),
          props: route => ({
            vacancyId: Number.parseInt(route.params.vacancyId, 10),
            step: route.params.step ? Number.parseInt(route.params.step, 10) : undefined,
          }),
          meta: {
            supportBtn: true,
          },
        },
        {
          path: 'vacancy/:vacancyId/continue',
          name: 'interviewContinue',
          component: () => import(/* webpackChunkName: "vacancy-interview-continue" */ '../views/InterviewContinue.vue'),
          props: route => ({
            vacancyId: Number.parseInt(route.params.vacancyId, 10),
          }),
          meta: {
            supportBtn: true,
          },
        },
        {
          path: 'vacancy/:vacancyId/continue_test',
          name: 'interviewTestContinue',
          component: () => import(/* webpackChunkName: "vacancy-interview-continue" */ '../views/InterviewTestContinue.vue'),
          props: route => ({
            vacancyId: Number.parseInt(route.params.vacancyId, 10),
          }),
          meta: {
            supportBtn: true,
          },
        },
        {
          path: 'vacancy/:vacancyId/result',
          name: 'interviewResult',
          component: () => import(/* webpackChunkName: "interview-result" */ '../views/InterviewResult.vue'),
          props: route => ({
            companyId: Number.parseInt(route.params.companyId, 10),
            vacancyId: Number.parseInt(route.params.vacancyId, 10),
          }),
        },
        {
          path: '/confidential',
          name: 'confidential',
          component: () => import(/* webpackChunkName: "confidential" */ '../views/privacyPolicy/Confidential.vue'),
        },
        {
          path: '/donotsell',
          name: 'doNotSellPersonalInformation',
          component: () => import(/* webpackChunkName: "doNotSellPersonalInformation" */ '../views/privacyPolicy/DoNotSellPersonal.vue'),
        },
        {
          path: '/agree',
          name: 'agree',
          component: () => import(/* webpackChunkName: "agree" */ '../views/Agree.vue'),
        },
        {
          path: '/rules',
          name: 'rules',
          component: () => import(/* webpackChunkName: "rules" */ '../views/Rules.vue'),
        },
        {
          path: '/ru/payment-info',
          name: 'ru-payment-info',
          component: () => import(/* webpackChunkName: "payment-rules" */ '../views/PaymentRules.vue'),
        },
      ],
    },
    {
      path: '/iframe/h/:hashId',
      name: 'iframeCandidateInviteLink',
      component: () => import(/* webpackChunkName: "iframe-candidate-invite-link" */ '../views/IframeCandidateInviteLink'),
      props: route => ({ hashId: String(route.params.hashId) }),
      meta: {
        iframe: true,
      },
    },
    {
      path: '/h/iframe/:hashId',
      name: 'iframeCandidatePersonalLink',
      component: () => import(/* webpackChunkName: "candidate-personal-link" */ '../views/CandidatePersonalLink.vue'),
      props: route => ({ hashId: String(route.params.hashId) }),
      meta: {
        iframe: true,
      },
    },
    {
      path: '/iframe/company/:companyId/vacancy/:vacancyId/reply/:hashId?',
      name: 'iframeVacancyReply',
      component: () => import(/* webpackChunkName: "vacancy-reply" */ '../views/VacancyReply.vue'),
      props: route => ({
        vacancyId: Number.parseInt(route.params.vacancyId, 10),
        companyId: Number.parseInt(route.params.companyId, 10),
        hashId: route.params.hashId,
      }),
      meta: {
        iframe: true,
      },
    },
    {
      path: '/iframe/communication/:code',
      name: 'iframeCommunication',
      component: () => import(/* webpackChunkName: "employer-message" */ '../views/EmployerMessage.vue'),
      props: route => ({ code: String(route.params.code) }),
      meta: {
        iframe: true,
      },
    },
    {
      path: '/h/:hashId',
      name: 'candidatePersonalLink',
      component: () => import(/* webpackChunkName: "candidate-personal-link" */ '../views/CandidatePersonalLink.vue'),
      props: route => ({ hashId: String(route.params.hashId) }),
    },
    {
      path: '/communication',
      component: () => import(/* webpackChunkName: "app-company" */ '../app/AppCompany.vue'),
      children: [
        {
          path: ':code',
          name: 'employerMessage',
          component: () => import(/* webpackChunkName: "employer-message" */ '../views/EmployerMessage.vue'),
          props: route => ({ code: String(route.params.code) }),
        },
      ],
    },
    {
      path: '/ios/h/:hashId',
      name: 'candidatePersonalIosStubLink',
      component: () => import(/* webpackChunkName: "candidate-personal-link" */ '../views/IosStub.vue'),
      props: route => ({ hashId: String(route.params.hashId) }),
    },
    {
      path: '/ios/v/:vacancyId',
      name: 'vacancyIosStubLink',
      component: () => import(/* webpackChunkName: "candidate-personal-link" */ '../views/IosStub.vue'),
      props: route => ({ vacancyId: Number.parseInt(route.params.vacancyId, 10) }),
    },
    {
      path: '*',
      component: () => import(/* webpackChunkName: "app-company-default" */ '../app/AppCompany.vue'),
      children: [
        {
          path: '/p/:token',
          name: 'candidateSharedLink',
          component: () => import(/* webpackChunkName: "candidate-shared-link" */ '../views/CandidateSharedLink.vue'),
          props: route => ({
            token: String(route.params.token),
          }),
        },
        {
          path: '/qr/:vacancyListId',
          name: 'vacanciesList',
          component: () => import(/* webpackChunkName: "vacancies" */ '../views/VacanciesList.vue'),
          props: route => ({
            id: Number.parseInt(route.params.vacancyListId, 10),
          }),
        },
        {
          path: '*',
          name: '404',
          component: () => import(/* webpackChunkName: "error-four-o-four" */ '../views/Error404.vue'),
        },
      ],
    },
  ],
});
